import { Badge } from "../ui/badge";

const STATUS = {
  active: { label: "Ativo", cls: "bg-emerald-100 text-emerald-800 hover:bg-emerald-100" },
  overdue: { label: "Vencido", cls: "bg-rose-100 text-rose-800 hover:bg-rose-100" },
  pending: { label: "Aguardando pagamento", cls: "bg-amber-100 text-amber-800 hover:bg-amber-100" },
  blocked: { label: "Bloqueado", cls: "bg-neutral-200 text-neutral-700 hover:bg-neutral-200" },
};

export function StatusBadge({ status }) {
  const s = STATUS[status] || STATUS.pending;
  return <Badge className={`${s.cls} border-0`}>{s.label}</Badge>;
}

export function SituationBadge({ member }) {
  const s = STATUS[member.situation] || STATUS.pending;
  return (
    <Badge className={`${s.cls} border-0 whitespace-nowrap`} data-testid={`situation-${member.id}`}>
      {s.label}
      {member.situation === "overdue" && ` · ${member.days_overdue}d`}
    </Badge>
  );
}

export function StatCard({ icon: Icon, label, value, tone = "default", testId }) {
  const tones = {
    default: "bg-white border-neutral-200",
    primary: "bg-[#052E16] text-white border-[#052E16]",
    warn: "bg-amber-50 border-amber-200",
    ok: "bg-emerald-50 border-emerald-200",
    err: "bg-rose-50 border-rose-200",
  };
  return (
    <div className={`rounded-2xl border p-5 ${tones[tone]}`} data-testid={testId}>
      <Icon className="w-5 h-5 opacity-80" />
      <p className={`mt-3 text-xs font-semibold tracking-wider ${tone === "primary" ? "text-emerald-200" : "text-neutral-500"}`}>
        {label}
      </p>
      <p className="font-display text-2xl md:text-3xl font-extrabold mt-1" data-testid={`${testId}-value`}>
        {value}
      </p>
    </div>
  );
}
